class PageWishlist extends HTMLElement {
  constructor() {
    super();
    
    this.content = this.querySelector('[page-wishlist-product]');
    this.header = document.querySelector('header-wishlist');
    this.textRemove = this.content.dataset.remove;
    
    const session = localStorage.getItem('wishlist-storage');
    if (session !== null && session !== '[]' && session !== '[null]') {
      this.show(session);
    } else {
      this.classList.add('is-empty');
    }
  }
  
  show(session) {
    const products = JSON.parse(session);
    this.content.classList.add('is-loading');
    this.showContent(products);
  }
  
  remove() {
    this.querySelectorAll('[data-wishlist-handle]').forEach(
      (action) => {
        action.title = this.textRemove;
        action.addEventListener('click', this.onButtonClick.bind(this));
      }
    );
  }
  
  onButtonClick(event) {
    event.preventDefault();
    const parent = event.target.closest('.product-item__content');
    parent.classList.add('is-hidden');
    const session = localStorage.getItem('wishlist-storage');
    if (JSON.parse(session).length === 0) {
      this.classList.add('is-empty');
    }
    this.header.init();
  }

  async showContent(products) {
  const availableProducts = [];

  try {
    for (const [index, handle] of products.entries()) {
      if (!handle || typeof handle !== 'string') continue;

      try {
        const url = `/products/${encodeURIComponent(handle)}?view=item-wishlist`;
        const html = await $.get(url);

        if (!html || !String(html).trim()) continue;

        const item = document.createElement('div');
        item.className = `col product-item__content product-item__content-${index}`;
        item.innerHTML = html;

        this.content.appendChild(item);
        availableProducts.push(handle);

      } catch (error) {
        console.warn('Wishlist product unavailable:', handle);
      }
    }

    localStorage.setItem(
      'wishlist-storage',
      JSON.stringify(availableProducts)
    );

    if (availableProducts.length === 0) {
      this.classList.add('is-empty');
    } else {
      this.classList.remove('is-empty');
      this.remove();
    }

    this.header?.init();

  } catch (error) {
    console.error('Wishlist loading error:', error);
  } finally {
    this.content.classList.remove('is-loading');
  }
}
}

customElements.define('page-wishlist', PageWishlist);